import {
  parseCheckoutError
} from "./chunk-WWLG26XU.mjs";
import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/checkout.ts
import { getItem, getLocaleOnly, readCookie } from "@wbk/utils";
import { CheckoutException } from "@wbk/logger";
var checkout = (_0) => __async(void 0, [_0], function* ({
  order,
  usePaymentApi,
  isSeason,
  isSeat,
  email,
  locale,
  v2,
  isBestAvailable = false
}) {
  var _a, _b, _c, _d, _e, _f;
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield generateRecaptchaToken("checkout");
    const seasonUrl = isSeat ? "/season-seat/checkout" : "/season/checkout";
    const seatedEventUrl = isBestAvailable ? "/checkout/hold-best-available" : "/event-seat/checkout";
    const eventUrl = isSeat ? seatedEventUrl : "/checkout";
    const url = v2 ? "/checkout/v2" : isSeason ? seasonUrl : eventUrl;
    const isTWK = readCookie("twk") === "true";
    const app_source = isTWK ? "twk" : (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource;
    const savedUtms = getItem("utms");
    const utm = savedUtms ? JSON.parse(savedUtms) : null;
    const data = yield fetchClient({
      baseUrl: usePaymentApi ? (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.paymentApi : void 0,
      url: `${url}?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues(__spreadProps(__spreadValues({}, order), { captcha, app_source, lang }), utm))
      }
    });
    if (((_e = data == null ? void 0 : data.status) == null ? void 0 : _e.toLowerCase()) !== "success") {
      const possibleObj = typeof (data == null ? void 0 : data.message) === "object" ? data == null ? void 0 : data.message : { message: ((_f = data == null ? void 0 : data.error) == null ? void 0 : _f.message) || (data == null ? void 0 : data.message) };
      const msg = Object.values(possibleObj || {})[0];
      const msgString = Array.isArray(msg) ? msg[0] : msg;
      throw new Error(msgString || "Something went wrong");
    }
    return data.data;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});
var checkoutPackage = (_0) => __async(void 0, [_0], function* ({ usePaymentApi, order, email, locale }) {
  var _a, _b, _c, _d;
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield generateRecaptchaToken("checkout");
    const data = yield fetchClient({
      baseUrl: usePaymentApi ? (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.paymentApi : void 0,
      url: `/bundles/checkout?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, order), { captcha, lang }))
      }
    });
    if (((_c = data == null ? void 0 : data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      throw new Error(((_d = data == null ? void 0 : data.error) == null ? void 0 : _d.message) || (data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data.data;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});
var checkoutResell = (_0) => __async(void 0, [_0], function* ({
  usePaymentApi,
  order,
  slug,
  email,
  locale
}) {
  var _a, _b, _c, _d;
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield generateRecaptchaToken("checkout");
    const url = `/resale-listing/${slug}/checkout`;
    const data = yield fetchClient({
      baseUrl: usePaymentApi ? (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.paymentApi : void 0,
      url: `${url}?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, order), { captcha, lang }))
      }
    });
    if (((_c = data == null ? void 0 : data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      throw new Error(((_d = data == null ? void 0 : data.error) == null ? void 0 : _d.message) || (data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data.data;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});
var checkoutToHy = (_0) => __async(void 0, [_0], function* ({ order, locale, email, usePaymentApi }) {
  var _a, _b, _c, _d, _e, _f;
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield generateRecaptchaToken("checkout");
    const url = "/halayalla/checkout";
    const app_source = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource;
    const savedUtms = getItem("utms");
    const utm = savedUtms ? JSON.parse(savedUtms) : null;
    const data = yield fetchClient({
      baseUrl: usePaymentApi ? (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.paymentApi : void 0,
      url: `${url}?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues(__spreadProps(__spreadValues({}, order), { captcha, app_source, lang }), utm))
      }
    });
    if (((_e = data == null ? void 0 : data.status) == null ? void 0 : _e.toLowerCase()) !== "success") {
      const possibleErrors = data.error || {};
      const msg = typeof possibleErrors === "string" ? possibleErrors : (_f = Object.values(possibleErrors)) == null ? void 0 : _f[0];
      const msgString = Array.isArray(msg) ? msg[0] : msg;
      throw new Error(msgString || "Something went wrong");
    }
    return data;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});

export {
  checkout,
  checkoutPackage,
  checkoutResell,
  checkoutToHy
};
//# sourceMappingURL=chunk-JIIZLDZ6.mjs.map